import { Outlet, Navigate } from 'react-router'
import { useAuthStore } from '@/state/authStore'

export default function AdminGuard() {
  const account = useAuthStore((s) => s.account)
  if (!account?.isAdmin) return <Navigate to="/" replace />
  return <Outlet />
}
